<template>
  <div>
    <div class="s-img" v-for="(item, index) in imgList" :key="index">
      <img :src="item.url" />
    </div>
    <a
      v-if="productInfo.tabId == 0"
      href="/world/闪开产品手册2026.pdf"
      target="downloadFile"
      download="闪开产品手册2026.pdf"
    >
      <div class="s-img">
        <img src="../assets/images/product/download.jpg" />
      </div>
    </a>
    <a
      v-if="productInfo.tabId == 1"
      href="/world/智慧照明画册.pdf"
      target="downloadFile"
      download="智慧照明画册.pdf"
    >
      <div class="s-img">
        <img src="../assets/images/product/download2.jpg" />
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productInfo: "",
      imgList: [],
      p1m1List: [
        { url: require(`@/assets/images/product/one/4-1_02.jpg`) },
        { url: require(`@/assets/images/product/one/4-1_03.jpg`) },
        { url: require(`@/assets/images/product/one/4-1_04.jpg`) },
        { url: require(`@/assets/images/product/one/4-1_05.jpg`) },
        { url: require(`@/assets/images/product/one/4-1_06.jpg`) },
        // { url: require(`@/assets/images/product/one/4-1_07.jpg`) },
      ],
      p1m2List: [
        { url: require(`@/assets/images/product/one/5-1_02.jpg`) },
        { url: require(`@/assets/images/product/one/5-1_03.jpg`) },
        { url: require(`@/assets/images/product/one/5-1_04.jpg`) },
        { url: require(`@/assets/images/product/one/5-1_05.jpg`) },
        { url: require(`@/assets/images/product/one/5-1_06.jpg`) },
        { url: require(`@/assets/images/product/one/5-1_07.jpg`) },
        // { url: require(`@/assets/images/product/one/5-1_08.jpg`) },
      ],
      p1m3List: [
        { url: require(`@/assets/images/product/one/6-1_02.jpg`) },
        { url: require(`@/assets/images/product/one/6-1_03.jpg`) },
        { url: require(`@/assets/images/product/one/6-1_04.jpg`) },
        { url: require(`@/assets/images/product/one/6-1_05.jpg`) },
        { url: require(`@/assets/images/product/one/6-1_06.jpg`) },
        // { url: require(`@/assets/images/product/one/6-1_07.jpg`) },
        // { url: require(`@/assets/images/product/one/6-1_08.jpg`) },
      ],
      p1m4List: [
        { url: require(`@/assets/images/product/one/7-1_02.jpg`) },
        { url: require(`@/assets/images/product/one/7-1_03.jpg`) },
        { url: require(`@/assets/images/product/one/7-1_04.jpg`) },
        { url: require(`@/assets/images/product/one/7-1_05.jpg`) },
        { url: require(`@/assets/images/product/one/7-1_06.jpg`) },
        { url: require(`@/assets/images/product/one/7-1_07.jpg`) },
        // { url: require(`@/assets/images/product/one/7-1_08.jpg`) },
      ],
      p1m5List: [
        { url: require(`@/assets/images/product/one/8-1_02.jpg`) },
        { url: require(`@/assets/images/product/one/8-1_03.jpg`) },
        { url: require(`@/assets/images/product/one/8-1_04.jpg`) },
        { url: require(`@/assets/images/product/one/8-1_05.jpg`) },
        { url: require(`@/assets/images/product/one/8-1_06.jpg`) },
        { url: require(`@/assets/images/product/one/8-1_07.jpg`) },
      ],
      p1m6List: [
        { url: require(`@/assets/images/product/slow-1-2/4-1_02.jpg`) },
        { url: require(`@/assets/images/product/slow-1-2/4-1_03.jpg`) },
        { url: require(`@/assets/images/product/slow-1-2/4-1_04.jpg`) },
        { url: require(`@/assets/images/product/slow-1-2/4-1_05.jpg`) },
        { url: require(`@/assets/images/product/slow-1-2/4-1_06.jpg`) },
        { url: require(`@/assets/images/product/slow-1-2/4-1_07.jpg`) },
      ],
      p1m7List: [
        { url: require(`@/assets/images/product/slow-2-3/5-2_02.jpg`) },
        { url: require(`@/assets/images/product/slow-2-3/5-2_03.jpg`) },
        { url: require(`@/assets/images/product/slow-2-3/5-2_04.jpg`) },
        { url: require(`@/assets/images/product/slow-2-3/5-2_05.jpg`) },
        { url: require(`@/assets/images/product/slow-2-3/5-2_06.jpg`) },
        { url: require(`@/assets/images/product/slow-2-3/5-2_07.jpg`) },
      ],
      p2m1List: [
        { url: require(`@/assets/images/product/two/9-1_02.jpg`) },
        { url: require(`@/assets/images/product/two/9-1_03.jpg`) },
        { url: require(`@/assets/images/product/two/9-1_04.jpg`) },
        { url: require(`@/assets/images/product/two/9-1_05.jpg`) },
        { url: require(`@/assets/images/product/two/9-1_06.jpg`) },
        { url: require(`@/assets/images/product/two/9-1_07.jpg`) },
      ],
      p2m2List: [
        { url: require(`@/assets/images/product/two/10-1_02.jpg`) },
        { url: require(`@/assets/images/product/two/10-1_03.jpg`) },
        { url: require(`@/assets/images/product/two/10-1_04.jpg`) },
        { url: require(`@/assets/images/product/two/10-1_05.jpg`) },
        { url: require(`@/assets/images/product/two/10-1_06.jpg`) },
        { url: require(`@/assets/images/product/two/10-1_07.jpg`) },
      ],
      p2m3List: [
        { url: require(`@/assets/images/product/two/11-1_02.jpg`) },
        { url: require(`@/assets/images/product/two/11-1_03.jpg`) },
        { url: require(`@/assets/images/product/two/11-1_04.jpg`) },
        { url: require(`@/assets/images/product/two/11-1_05.jpg`) },
        { url: require(`@/assets/images/product/two/11-1_06.jpg`) },
        { url: require(`@/assets/images/product/two/11-1_07.jpg`) },
      ],
      p2m4List: [
        { url: require(`@/assets/images/product/two/12-1_02.jpg`) },
        { url: require(`@/assets/images/product/two/12-1_03.jpg`) },
        { url: require(`@/assets/images/product/two/12-1_04.jpg`) },
        { url: require(`@/assets/images/product/two/12-1_05.jpg`) },
        { url: require(`@/assets/images/product/two/12-1_06.jpg`) },
        { url: require(`@/assets/images/product/two/12-1_07.jpg`) },
      ],
      p2m5List: [
        { url: require(`@/assets/images/product/two/13-1_02.jpg`) },
        { url: require(`@/assets/images/product/two/13-1_03.jpg`) },
        { url: require(`@/assets/images/product/two/13-1_04.jpg`) },
      ],
      p2m6List: [
        { url: require(`@/assets/images/product/new-1-1/1_01.jpg`) },
        { url: require(`@/assets/images/product/new-1-1/1_02.jpg`) },
        { url: require(`@/assets/images/product/new-1-1/1_03.jpg`) },
        { url: require(`@/assets/images/product/new-1-1/1_04.jpg`) },
        { url: require(`@/assets/images/product/new-1-1/1_05.jpg`) },
      ],
      p2m7List: [
        { url: require(`@/assets/images/product/new-1-2/1_01.jpg`) },
        { url: require(`@/assets/images/product/new-1-2/1_02.jpg`) },
        { url: require(`@/assets/images/product/new-1-2/1_03.jpg`) },
        { url: require(`@/assets/images/product/new-1-2/1_04.jpg`) },
        { url: require(`@/assets/images/product/new-1-2/1_05.jpg`) },
        { url: require(`@/assets/images/product/new-1-2/1_06.jpg`) },
      ],
      p2m8List: [
        { url: require(`@/assets/images/product/new-1-3/1_01.jpg`) },
        { url: require(`@/assets/images/product/new-1-3/1_02.jpg`) },
        { url: require(`@/assets/images/product/new-1-3/1_03.jpg`) },
        { url: require(`@/assets/images/product/new-1-3/1_04.jpg`) },
        { url: require(`@/assets/images/product/new-1-3/1_05.jpg`) },
        { url: require(`@/assets/images/product/new-1-3/1_06.jpg`) },
      ],
      p3m1List: [
        { url: require(`@/assets/images/product/tri/14-1_02.jpg`) },
        { url: require(`@/assets/images/product/tri/14-1_03.jpg`) },
        { url: require(`@/assets/images/product/tri/14-1_04.jpg`) },
        { url: require(`@/assets/images/product/tri/14-1_05.jpg`) },
        { url: require(`@/assets/images/product/tri/14-1_06.jpg`) },
        { url: require(`@/assets/images/product/tri/14-1_07.jpg`) },
        { url: require(`@/assets/images/product/tri/14-1_08.jpg`) },
      ],
    };
  },
  mounted() {
    var self = this;
    // 获取路由参数
    this.productInfo = this.$route.query;

    const type = this.productInfo.tabId;
    const id = this.productInfo.productId;
    console.log("当前type=>", type);
    console.log("当前id=>", id);
    if (type == 0) {
      if (id == 1) {
        self.imgList = self.p1m1List;
      } else if (id == 2) {
        self.imgList = self.p1m2List;
      } else if (id == 3) {
        self.imgList = self.p1m3List;
      } else if (id == 4) {
        self.imgList = self.p1m4List;
      } else if (id == 5) {
        self.imgList = self.p1m5List;
      } else if (id == 6) {
        self.imgList = self.p1m6List;
      } else if (id == 7) {
        self.imgList = self.p1m7List;
      }
    } else if (type == 1) {
      if (id == 0) {
        self.imgList = self.p2m1List;
      } else if (id == 1) {
        self.imgList = self.p2m6List;
      } else if (id == 2) {
        self.imgList = self.p2m7List;
      } else if (id == 3) {
        self.imgList = self.p2m8List;
      } else if (id == 4) {
        self.imgList = self.p2m2List;
      } else if (id == 5) {
        self.imgList = self.p2m3List;
      } else if (id == 6) {
        self.imgList = self.p2m4List;
      } else if (id == 7) {
        self.imgList = self.p2m5List;
      }
    } else if (type == 2) {
      self.imgList = self.p3m1List;
    }
    console.log("当前imgList=>", self.imgList);
  },
  methods: {
    //===下载文档=======
    downloadFile() {},
  },
};
</script>

<style></style>
